import React from "react";
import {FormattedMessage} from "react-intl";
import StatisticTag from "../StatisticTag";
import Icon from "../Utils/Icon";
import Loader from "../Utils/Loader";
import classes from "./styles.module.css";

function PayoutsFilters({onApplyFilters, onSelectFilter, onSelectedTag, tagsList, filterProjects, isLoading}) {
    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="PayoutsFilters.title.status" defaultMessage="Статус"/>
                    </h6>

                    <div className={classes.Column}>
                        <div className={classes.CheckboxWrap}>
                            <input id="created" type="checkbox"
                                   onChange={(e) => onSelectFilter({created: e.target.checked})}/>
                            <label htmlFor="created" className={classes.CustomCheckbox}>
                                <div className={classes.PendingIcon}/>
                                <span><FormattedMessage id="PayoutsFilters.status.created"
                                                        defaultMessage="Создан"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input id="inProgress" type="checkbox"
                                   onChange={(e) => onSelectFilter({inProgress: e.target.checked})}/>
                            <label htmlFor="inProgress" className={classes.CustomCheckbox}>
                                <div className={classes.InProgressIcon}/>
                                <span><FormattedMessage id="PayoutsFilters.status.inProgress"
                                                        defaultMessage="Обрабатывается"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input id="processed" type="checkbox"
                                   onChange={(e) => onSelectFilter({processed: e.target.checked})}/>
                            <label htmlFor="processed" className={classes.CustomCheckbox}>
                                <div className={classes.ProcessedIcon}/>
                                <span><FormattedMessage id="PayoutsFilters.status.processed" defaultMessage="Выполнен"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input id="processedWithErrors" type="checkbox"
                                   onChange={(e) => onSelectFilter({processedWithErrors: e.target.checked})}/>
                            <label htmlFor="processedWithErrors" className={classes.CustomCheckbox}>
                                <div className={classes.processedWithErrorsIcon}/>
                                <span><FormattedMessage id="PayoutsFilters.status.processedWithErrors"
                                                        defaultMessage="Выполнен с ошибками"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input id="delayed" type="checkbox"
                                   onChange={(e) => onSelectFilter({delayed: e.target.checked})}/>
                            <label htmlFor="delayed" className={classes.CustomCheckbox}>
                                <div className={classes.DelayedIcon}/>
                                <span><FormattedMessage id="PayoutsFilters.status.delayed"
                                                        defaultMessage="Отложен"/></span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="PayoutsFilters.title.tags" defaultMessage="Метки"/>
                    </h6>
                    <div className={classes.Column}>
                        <StatisticTag tagsList={tagsList} filterProjects={filterProjects}
                                      onSelectedTag={onSelectedTag}/>
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button onClick={onApplyFilters} className={classes.Submit} disabled={!isLoading}>
                    {isLoading ? (
                        <Icon className={classes.buttonIcon} icon="filter" size="17px"/>
                    ) : (
                        <Loader isString={true}/>
                    )}
                    <FormattedMessage id="PayoutsFilters.btn.filter" defaultMessage="Фильтровать"/>
                </button>
            </div>
        </div>
    );
}

export default PayoutsFilters;



// WEBPACK FOOTER //
// ./src/Components/PayoutsFilters/index.js